import { render, staticRenderFns } from "./drawerContent.vue?vue&type=template&id=22cc28bc&scoped=true"
import script from "./drawerContent.vue?vue&type=script&lang=js"
export * from "./drawerContent.vue?vue&type=script&lang=js"
import style0 from "./drawerContent.vue?vue&type=style&index=0&id=22cc28bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc28bc",
  null
  
)

export default component.exports